<template>
  <div v-if="offerPositionBoilerplate" class="forms-elements">
    <Breadcrumbs v-bind:breadcrumbs="breadcrumbs" />

    <Widget v-if="offerPositionBoilerplate">
      <b-row>
        <b-col lg="6" md="6" sm="12">
          <legend>
            <strong>{{ $t('basicData') }}</strong>
          </legend>

          <b-form-group
            horizontal
            :label="$t('name')"
            label-for="name"
            label-class="text-md-right"
            :label-cols="4"
            breakpoint="md"
          >
            <b-form-input
              v-model="offerPositionBoilerplate.name"
              type="text"
              :placeholder="$t('name')"
            />
          </b-form-group>

          <b-form-group
            horizontal
            :label="$t('description')"
            label-for="description"
            label-class="text-md-right"
            :label-cols="4"
            breakpoint="md"
          >
            <b-form-textarea
              v-model="offerPositionBoilerplate.description"
              :placeholder="$t('description')"
              rows="2"
              max-rows="8"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col lg="12" md="12" sm="12">
          <ButtonBar
            :showPreviousButton="false"
            :showNextButton="false"
            :showDeleteButton="false"
            :model="offerPositionBoilerplate"
            modelEditRoute="OfferPositionBoilerplateEditPage"
            modelListRoute="OfferPositionBoilerplatesPage"
            modelRouteParamName="offerPositionBoilerplateNumber"
            :updateCallback="updateOfferPositionBoilerplate"
            :createCallback="createOfferPositionBoilerplate"
            :fetchCallback="fetchOfferPositionBoilerplates"
          />
        </b-col>
      </b-row>
    </Widget>
  </div>
</template>

<script>
import Widget from '@/components/Widget/Widget';
import Breadcrumbs from '@/components/Breadcrumbs';
import { mapGetters, mapActions } from 'vuex';
import ButtonBar from '@/components/ButtonBar.vue';

export default {
  name: 'OfferPositionBoilerplateEditPage',
  components: {
    Widget,
    Breadcrumbs,
    ButtonBar,
  },
  props: {
    offerPositionBoilerplateNumber: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
      number: null,
      buttonsDisabled: false,
    };
  },
  computed: {
    ...mapGetters('auth', ['isAdmin']),
    ...mapGetters(['getOfferPositionBoilerplate', 'getOfferPositionBoilerplateByNumber']),

    offerPositionBoilerplate() {
      const offerPositionBoilerplate = this.getOfferPositionBoilerplateByNumber(this.number);
      return offerPositionBoilerplate;
    },

    isNew() {
      return this.offerPositionBoilerplate._id === '_new';
    },

    breadcrumbs() {
      return [
        { name: 'Home', route: { name: 'home' } },
        {
          name: this.$t('offerPositionBoilerplates'),
          route: { name: 'OfferPositionBoilerplatesPage' },
        },
        {
          name: this.offerPositionBoilerplate.number !== '_new' ? this.$t('edit') : this.$t('new'),
        },
      ];
    },
  },
  methods: {
    ...mapActions([
      'initOfferPositionBoilerplate',
      'fetchOfferPositionBoilerplates',
      'fetchOfferPositionBoilerplateByNumber',
      'updateOfferPositionBoilerplate',
      'createOfferPositionBoilerplate',
    ]),
  },
  async mounted() {
    if (!this.offerPositionBoilerplate && this.offerPositionBoilerplateNumber) {
      this.number = this.offerPositionBoilerplateNumber;
      await this.fetchOfferPositionBoilerplateByNumber(this.number);
    } else {
      this.initOfferPositionBoilerplate();
      this.number = '_new';
    }
  },
  async beforeRouteUpdate(to, from, next) {
    if (
      to.params.offerPositionBoilerplateNumber &&
      to.params.offerPositionBoilerplateNumber !== this.offerPositionBoilerplateNumber
    ) {
      this.$store.commit('SET_OFFER_POSITION_BOILERPLATE_DEFAULT_STATE');
      this.number = to.params.offerPositionBoilerplateNumber;
      await this.fetchOfferPositionBoilerplateByNumber(this.number);
      next();
    } else {
      next(false);
    }
  },
};
</script>

<style scoped lang="scss"></style>
